/* template */
<template><div :style="[(containerStyle)] | transRpxStyle" class="accelerate-progress-wrapper"><div class="status-title"><hl-text :text="(title)" :commonStyle="(commonStyle)" :hlStyle="(hlStyle)"/></div><div class="status-bar"><div v-for="(item, index) in (statusList)" :class="(item.isActive && 'now')" class="status-item"><mpx-image :src="(item.isActive? item.activeIcon:item.icon)" mode="heightFix" class="icon"/>{{ item.text }}<div :class="({white: currentStatus >= index + 1, now: item.isActive})" class="line"/></div></div><div class="progress-wrapper"><div :class="(inited && 'transition')" :style="[(progressStyle)] | transRpxStyle" class="progress-bar"><mpx-image :style="[(picStyle)] | transRpxStyle" src="https://ut-static.udache.com/webx/sfc/ChvHk36XRci9CdWj17fPy.gif" :mode="(mode)" class="pic"/></div></div><div class="btn-area" v-if="(!highest)"><mpx-view id="share-btn" :class='("share-btn "+(isAccelerateShare ? "":"disabled"))' @tap="share" v-if="(!isHarmonyos)"><div class="share-btn-title">邀人加速</div><div class="share-btn-text"><hl-text :text="(inviteText)" :commonStyle="(shareBtnCommomStyle)"/></div></mpx-view><mpx-view id="update-btn" @tap="handleClick" class="update-btn"><div class="update-btn-text">直接加速</div></mpx-view></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m12c887da"}'>
  .accelerate-progress-wrapper
    width 100%
    box-sizing border-box
    background linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(180deg, #FFF3EA 2%, #FFFFFF 27%)
    padding 9px 14px 0 14px
    display flex
    flex-direction column
    border-radius 10px
    margin-bottom 8px
    border 2px solid #FFFFFF
    .status-title
      margin-bottom 13px
    .status-bar
      display flex
      justify-content space-between
      align-items center
      font-family PingFangSC-Regular
      font-size 11px
      font-weight 400
      letter-spacing 0px
      color #666
      margin-bottom 8px
      .status-item
        position relative
        box-sizing border-box
        line-height 12px
        display flex
        align-items center
        z-index 2
        .icon
          height 11px
          margin-right 1.5px
        .line
          position absolute
          left 50%
          bottom -15px
          transform  translate(-50%, 100%)
          height 5px
          width 1px
          border-radius 1px
          background #ff5900
          opacity 0.15
          &.now
            bottom -11px
          &.white
            background #fff
        &.now
          color #FF5900
          font-size 12px
          padding 4px 5.5px
          font-family PingFangSC-Medium
          font-weight 600
    .progress-wrapper
      width 100%
      height 11px
      border-radius 2px
      background #FFEEE6
      margin-bottom 20px
      padding-right 10px
      box-sizing border-box
      position relative
      .progress-bar
        position relative
        height 100%
        border-radius 3.5px 0 0 3.5px
        background #FF5800
        .pic
          height 20px
          position absolute
          top 50%
          right -25px
          transform translateY(-50%)
        &.transition
          transition-property width
          transition-timing-function ease-in-out
    .btn-area
      width 100%
      display flex
      justify-content space-between
      align-items center
      padding-bottom 16px
      .share-btn
        display flex
        align-items center
        justify-content center
        flex-direction column
        padding 0px 15px
        min-width 107px
        height 44px
        box-sizing border-box
        color #FF5900
        font-family: PingFang SC;
        border-radius: 8px;
        background: linear-gradient(0deg, rgba(255, 238, 230, 0.9), rgba(255, 238, 230, 0.9))
        .share-btn-title
          font-size: 14px;
          font-weight: 500;
          line-height: 14px;
          letter-spacing: 0px;
        .share-btn-text
          font-size: 10px;
          font-weight: normal;
          line-height: 12px;
          text-align: center;
          letter-spacing: 0px;
          margin-top 3px
      .share-btn.disabled
        background: linear-gradient(0deg, #E9EFF3, #E9EFF3)
        color: rgba(153, 153, 153, 0.8);
      .update-btn
        height: 44px;
        border-radius: 8px;
        background: #FF5900;
        display flex
        justify-content center
        align-items center
        margin-left 8px
        flex: 1;
        .update-btn-text
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: 500;
          line-height: 14px;
          letter-spacing: 0px;
          color: #FFFFFF;

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m12c887da"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./accelerate-progress.mpx.js?isComponent&outputPath=components%2Faccelerate-progress12c887da%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./accelerate-progress.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Faccelerate-progress12c887da%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m12c887da"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/accelerate-progress12c887da/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'hl-text':getComponent(require("../../../components/hl-text/index.mpx?isComponent&outputPath=components%2Findex10de904a%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
